import {
  Button,
  Col,
  Dropdown,
  Input,
  Menu,
  Select,
  Row,
  Slider,
  Space,
  Switch,
} from "antd";
import React, { useEffect } from "react";
import { Label } from "reactstrap";
import { EllipsisOutlined } from "@ant-design/icons";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { LogEvents, LoggerContext } from "../../../context/logging";
const SearchFilterDirectory = (props) => {
  const { Option } = Select;
  const { Search } = Input;
  const logger = React.useContext(LoggerContext);

  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);

  const fetchCategories = () => {
    axios
      .get(`mdV1/categories/`)
      .then((res) => {
        setCategory(res.data);
      })
      .catch((error) => {
        toast.error("Something went wrong!");
      });
  };

  const categoryOptions = category?.map((each) => (
    <Option key={each?.title} value={each?.title}>
      {each?.title}
    </Option>
  ));
  const kmOptions = ["25", "50", "100", "5000"]?.map((each) => (
    <Option key={each} value={each}>
      {each == "5000" ? "PAN India " : each} {each === "5000" ? null : "Km"}
    </Option>
  ));
  const [pincode, setPincode] = useState("560102");
  const [km, setKm] = useState("5000");
  const [search, setSearch] = useState("");

  useEffect(() => {
    document.addEventListener("keyup", function (event) {
      if (event.code === "Enter") {
        props.fetchVendors({ pincode, km });
      }
    });
    // fetchCategories();
  }, []);

  useEffect(() => {
    console.log("page in search filter ", props.pages);
  }, [props.pages]);

  const handleSearchByPincode = () => {
    console.log("handleSearchByPincode", selectedCategory);
    props.fetchVendors({
      pincode: pincode,
      km: km,
      // category: selectedCategory,
      search: search,
    });
  };
  return (
    <Col>
      {props.empaneled ? (
        <Row gutter={24}>
          <Col sm={4}>
            <Label>Search by pincode</Label>
            <Input
              name="search"
              onChange={(e) => {
                setPincode(e.target.value);
                props.setHeadPinCode(e.target.value);
              }}
              value={pincode}
              type="number"
              placeholder="Search by pincode"
              className="w-100"
              onKeyDown={(e) => {
                // e.preventDefault()
                if (e.key === "Enter") {
                  e.preventDefault();
                  console.log("enter");
                  props.fetchVendors({ pincode, km });
                }
              }}
            />
          </Col>
          <Col sm={4}>
            <Label>Search by Distance</Label>
            <br />
            <Select
              placeholder="Select Distance"
              value={km}
              defaultValue={km}
              onChange={(value) => {
                logger.log(LogEvents.filterByDistance, {});
                setKm(value);
                props.setHeadkm(value);
              }}
            >
              {kmOptions}
            </Select>
          </Col>
          <Col sm={7}>
            <Label>Search</Label>
            <br />

            <Search
              placeholder="Search vendors"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              onSearch={(value) => {
                if (value?.length > 0) {
                  props.fetchVendors({ search: value });
                } else {
                  props.fetchVendors({});
                }
              }}
            />
            {/* <Select
                allowClear
                mode="multiple"
                showSearch
                onChange={(e) => {
                  console.log(e);
                  // hanleSearch(e);
                  props.setSelectedCategories(e);
                }}
                placeholder="Categories"
                className="w-100"
                filterOption={(input, option) =>
                  option.children
                    ?.toLowerCase()
                    .indexOf(input?.toLowerCase()) >= 0
                }
              >
                {categoryOptions}
              </Select> */}
          </Col>
          <Col sm={4}>
            <Label style={{ visibility: "hidden" }}>Search</Label>
            <br />
            <Button
              className="btn btn-primary"
              onClick={() => {
                logger.log(LogEvents.searchEmpaneledVendor, {});
                handleSearchByPincode();
              }}
              type="primary"
            >
              Search
            </Button>
          </Col>
        </Row>
      ) : (
        <Row justify="end">
        </Row>
      )}
    </Col>
  );
};

export default SearchFilterDirectory;
